module.exports = __webpack_public_path__ + "img/alignment_175.7f7c644c.jpg";